import { isNotFuture } from '@sword-health/input-validation/dist/scripts/date-validators'
import validationsRegex from '@sword-health/input-validation/dist/scripts/regex'
import { ZodString, ZodObject, ZodDate } from 'zod'
import { VALIDATION_TYPES } from '@/utils/zod/zod-keys'

ZodString.prototype.validChars = function (regexValue) {
  return this.regex(regexValue)
}

ZodString.prototype.emailFormat = function () {
  return this.regex(validationsRegex.email.global).describe({ type: VALIDATION_TYPES.emailFormat })
}

ZodString.prototype.maxLengthMinusOffset = function (maxLengthParam, offset) {
  return this.refine((value) => String(value).length <= maxLengthParam + offset)
    .describe({ type: VALIDATION_TYPES.maxLength, params: { max: maxLengthParam } })
}

ZodObject.prototype.passwordMatch = function (passwordKey, confirmationKey) {
  return this.refine((value) => value[passwordKey] === value[confirmationKey], { path: [confirmationKey] })
    .describe({ type: VALIDATION_TYPES.custom.passwordMatch })
}

ZodString.prototype.validUrl = function () {
  return this.regex(validationsRegex.url.general).describe({ type: VALIDATION_TYPES.custom.url })
}

ZodString.prototype.maxLengthOfDecimalNumber = function (integerMax, fractionalMax) {
  return this.refine((val) => {
    const [intPart, fracPart = ''] = val.split('.')

    return (intPart.length <= integerMax && fracPart.length <= fractionalMax)
  }).describe({ type: VALIDATION_TYPES.maxLength, params: { max: integerMax + fractionalMax + 1 } })
}

ZodString.prototype.maxValue = function (maxValue) {
  return this.refine((val) => {
    const intVal = Number(val)

    return intVal <= maxValue
  }).describe({ type: VALIDATION_TYPES.maxValue, params: { max: maxValue } })
}

ZodDate.prototype.isNotFuture = function () {
  return this.refine((value) => isNotFuture(value))
    .describe({ type: VALIDATION_TYPES.isNotFuture })
}
